import 'trade-in/components/TradeInCta/TradeInCta.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { ContentZonesService, LocaleService, WindowProxy } from '@sm360/widget-commons-core-services';
import { Account, AccountService, REDIRECTIONS, ModalService } from '@sm360/widget-commons-general';
import TradeInCtaItem from 'trade-in/components/TradeInCta/TradeInCtaItem/TradeInCtaItem.jsx';
import { noop } from 'lodash';

const SignUpModal = ModalService.get('login/SignUpModal');
const SignInModal = ModalService.get('login/SignInModal');
const SaveConfirmationModal = ModalService.get('login/SaveConfirmationModal');
const TradeInModal = ModalService.get('trade-in-estimate-modal');
const OfficialTradeInModal = ModalService.get('trade-in-official-modal');

const closeModal = () => {
    TradeInModal.close();
};

const redirectToHomepage = () => {
    const windowProxy = WindowProxy.get();
    if (windowProxy) {
        windowProxy.location.assign(REDIRECTIONS[LocaleService.getSimpleLocale()].homepage);
    }
};

const advisorAppointment = () => {
    const windowProxy = WindowProxy.get();
    if (windowProxy) {
        windowProxy.location.assign(REDIRECTIONS[LocaleService.getSimpleLocale()].advisorAppointment);
    }
};

const TradeInCta = ({
    isOfficialTradeInActivated,
    isRenderedInModal,
    isShowroomV2Enabled,
    saveTradeIn,
    account,
    goToOfficialTradeInForm,
}) => {
    const loginToSave = () => {
        [SignUpModal, SignInModal, SaveConfirmationModal].forEach((modal) => {
            modal.addCallbacks({
                onClose: () => {
                    saveTradeIn();
                    return true;
                },
            });
        });
        SignUpModal.open({ context: 'widget.login.signup.information', account, hasConfirmation: true });
        TradeInModal.close();
    };

    const loginToOfficialize = () => {
        if (!AccountService.isAuthenticated()) {
            [SignUpModal, SignInModal].forEach((modal) => {
                modal.addCallbacks({
                    onClose: () => {
                        if (AccountService.isAuthenticated()) {
                            OfficialTradeInModal.open();
                        }
                        return true;
                    },
                });
            });
            TradeInModal.close();
            SignUpModal.open({ context: 'widget.login.signup.information', account });
        } else if (goToOfficialTradeInForm) {
            goToOfficialTradeInForm();
        } else {
            TradeInModal.close();
            OfficialTradeInModal.open();
        }
    };

    const ctaOfficialValueContent = ContentZonesService.getContentZone('widget.tradein', 'cta.official.value')
        ? ContentZonesService.getContentZone('widget.tradein', 'cta.official.value').getValue()
        : `<ul>
        <li>${LocaleService.t('TRADE_IN.CTA.OFFICIAL.DEFAULT_1')}</li>
        <li>${LocaleService.t('TRADE_IN.CTA.OFFICIAL.DEFAULT_2')}</li>
        </ul>`;

    const wrapper = (
        <div className="TradeInCta__wrapper">
            {isOfficialTradeInActivated && (
                <h1 className="sr-subtitle-1 is-centered">
                    {!AccountService.isAuthenticated()
                        ? LocaleService.t('TRADE_IN.CTA.LOGGED_OUT_TITLE')
                        : LocaleService.t('TRADE_IN.CTA.LOGGED_IN_TITLE')}
                </h1>
            )}

            <div className="TradeInCta__content">
                {isShowroomV2Enabled &&
                    !AccountService.isAuthenticated() && (
                        <TradeInCtaItem
                            classesName={['sr-button-2', 'save-estimate']}
                            dataTest="trade-in.trade-in-cta.save-trade-in"
                            onClick={loginToSave}
                            buttonText={LocaleService.t('TRADE_IN.CTA.SAVE_TRADE_IN_VALUE')}
                            content=""
                        />
                    )}

                {AccountService.isAuthenticated() && (
                    <TradeInCtaItem
                        classesName={['sr-button-2']}
                        dataTest="trade-in.trade-in-cta.dealership-evaluation"
                        onClick={advisorAppointment}
                        buttonText={LocaleService.t('TRADE_IN.CTA.IN_PERSON')}
                        content=""
                    />
                )}

                {isOfficialTradeInActivated && (
                    <TradeInCtaItem
                        classesName={['sr-button-1', 'get-official']}
                        dataTest="trade-in.trade-in-cta.get-official-trade-in"
                        onClick={loginToOfficialize}
                        buttonText={
                            !AccountService.isAuthenticated()
                                ? LocaleService.t('TRADE_IN.CTA.OFFICIAL.LOGGED_OUT_TITLE')
                                : LocaleService.t('TRADE_IN.CTA.OFFICIAL.LOGGED_IN_TITLE')
                        }
                        content={{ __html: ctaOfficialValueContent }}
                    />
                )}
            </div>
            {isShowroomV2Enabled && (
                <p className="sr-disclaimer is-centered is-light fineprint">
                    {LocaleService.t('TRADE_IN.CTA.DISCLAIMER')}
                </p>
            )}
            <button
                className="sr-link continue-shopping"
                onClick={isRenderedInModal ? closeModal : redirectToHomepage}
                dataTest="trade-in.trade-in-cta.continue-shopping"
            >
                {LocaleService.t('TRADE_IN.CTA.BACK_TO_SHOP.TITLE')}
            </button>
        </div>
    );
    return wrapper;
};

TradeInCta.defaultProps = {
    saveTradeIn: noop,
    account: new Account(),
};

TradeInCta.propTypes = {
    isOfficialTradeInActivated: PropTypes.bool.isRequired,
    isRenderedInModal: PropTypes.bool.isRequired,
    isShowroomV2Enabled: PropTypes.bool.isRequired,
    saveTradeIn: PropTypes.func,
    account: PropTypes.instanceOf(Account),
    goToOfficialTradeInForm: PropTypes.func.isRequired,
};

TradeInCta.displayName = 'TradeInCta';
export { closeModal, redirectToHomepage, advisorAppointment };
export default TradeInCta;



// WEBPACK FOOTER //
// ./src/components/TradeInCta/TradeInCta.jsx